import styled from "@emotion/styled";
import Tooltip from "@components/Tooltips/Tooltip";

export const PlanedAbsenceBlockContainer = styled.div`
    width:100%;
    display:grid;
    grid-template-columns:1fr;
    border-radius: 5px;
    border: 1px solid ${props => props.theme.colors.placeholderColor};
    font-size: 14px;
    transition: all 0.15s ease-in-out;

    span{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;
        color: #000;
        transition: all 0.15s ease-in-out;
    }
    b{
        color: ${props => props.theme.colors.placeholderColor};
        transition: all 0.15s ease-in-out;
    }

    span:nth-of-type(even){
        text-align: right;
    }

    :hover{
        box-shadow: 0 0 4px 0 ${props => props.theme.colors.blue_50};
    }
`;

export const Top = styled.div`
    padding: 1px 0;
    display:flex;
    align-items: center;
    gap:10px;
    padding:5px 10px 0 10px;
    span{
        font-weight: 500;
        color: #2A848E;

    }
    svg{
        height:16px;
    }
`;

export const ActionBar = styled.div`
    margin-left: auto;
    display: flex;
    gap:0.5rem;

    button{
        height:16px;

        svg{
            height:100%;
        }
    }
`;

export const Middle = styled.div`
    padding:0 10px 0px 10px;

    p{
        word-break: break-all;
        font-size: 14px;
    }
`;

export const Bottom = styled.div`
    border-top: 1px solid #2A848E;
`;

export const BTop = styled.div<{open?:boolean}>`
    display:flex;
    align-items: center;
    background:${props => props.open?"#2a848e26":"#fff"};
    height:28px;
    padding:0 10px 0px 10px;
    gap:10px;

    svg{
        height:16px;

        :nth-of-type(2){
            transform: rotate(${props => props.open?"180deg":"0deg"});
            height:18px;
            path{
                fill:#2A848E;
            }
        }
    }

    span{
        font-weight: 500;
        color: #2A848E;

        :nth-of-type(2){
            margin-left: auto;
            font-size: 12px;
        }
    }
`;

export const BContent = styled.div<{open?:boolean}>`
    padding:5px 10px 5px 10px;
    overflow: hidden;
    display:${props => props.open?"block":"none"};
`;

export const Lecture = styled.div`
    padding: 1px 0;
    display:flex;
    align-items: center;
    gap:6px;
    
    span{
        font-weight: 500;
        color: ${props => props.theme.colors.placeholderColor};

        :nth-of-type(1){
            width:96px;
            display:flex;
            justify-content: space-between;
            margin-right:10px;
            b{
                font-weight: 500;
            }
        }
    }

    svg{
        height:14px;
    }
`;

export const PillContainer = styled.div`
    display:flex;
    flex-wrap: wrap;
    justify-content: end;
    padding:8px 10px 8px 10px;
    gap:5px;
`;

export const TagPill = styled.div<{bgColor?:string}>`
    background: ${props => props.bgColor?"#" + props.bgColor:"#959595"};
    color:#fff;
    font-size: 12px;
    padding:2px 10px;
    border-radius: 5px;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
`;